module.exports = __webpack_public_path__ + "img/roct.5663979a.svg";